








































































































































































































import { Component, Mixins, Watch } from 'vue-property-decorator'
import VueRouter from 'vue-router'
import GlobalMixin, {ALERT_TYPE} from '@/mixins/globalMixin'
import LoadingComponent from '@/components/LoadingComponent.vue'
import AlertBarComponent from '@/components/AlertBarComponent.vue'
import BreadcrumbsComponent from '@/components/BreadcrumbsComponent.vue'
import SelectDaysComponent from '@/components/SelectDaysComponent.vue'
import CustomerSelectDialogComponent from '@/components/CustomerSelectDialogComponent.vue'
import PdfViewComponent from '@/components/PdfViewComponent.vue'
import SendMailDialogComponent from '@/components/SendMailDialogComponent.vue'
import { Estimate, MailQueue } from '@/domain/Estimate'
import { SendMail } from '@/domain/SendMail'
import { WindowPosition } from '@/domain/WindowPosition'
import EstimatesService, { SerchConditon } from '@/service/EstimatesService'

@Component({
  components: {
    LoadingComponent,
    AlertBarComponent,
    BreadcrumbsComponent,
    SelectDaysComponent,
    CustomerSelectDialogComponent,
    PdfViewComponent,
    SendMailDialogComponent,
  },
})
export default class MemberEstimateList extends Mixins(GlobalMixin) {
  estimatesService = EstimatesService.instance

  /** 検索条件 */
  conditions = new SerchConditon()
  /** データテーブル ヘッダー設定 */
  searchFilter = ""
  headers = [
          { text: "見積日", value: "estimateOn", width: "100px" },
          { text: "見積番号", value: "estimateNo", width: "120px" },
          { text: "顧客名", value: "customerInfo.customerName", width: "240px" },
          { text: "検査項目", value: "sumInfo.inspectionNames" },
          { text: "小計", value: "sumInfo.amount", align: "end", filterable: false, width: "100px" },
          { text: "消費税", value: "sumInfo.tax", align: "end", filterable: false, width: "100px" },
          { text: "見積金額", value: "sumInfo.totalAmount", align: "end", filterable: false, width: "100px" },
          { text: "印刷", value: "printAt", align: "center", filterable: false, width: "80px" },
          { text: "メール", value: "mailSendAt", align: "center", filterable: false, width: "100px" },
          { text: "他文書", value: "links", filterable: false, sortable: false, width: "50px"  },
          { text: "操作", value: "actions", filterable: false, sortable: false, width: "160px" },
  ]
  list: Estimate[] = []
  selectItems: Estimate[] = []
  rowItemKey = ""
  rowItemClickTime = 0
  customerName = ""
  mailSendEstimateNos: string[] = []
  sendMail = new SendMail()

  /**
   * 選択リストのバリデーション
   */
  get isValidate() {
    const keys = this.selectItems.map(x => `${x.customerInfo.customerPrefectureCode}:${x.customerInfo.customerCode}:${x.customerInfo.customerBranchNumber}:${x.agencyInfo.agencyPrefectureCode}:${x.agencyInfo.agencyCode}:${x.agencyInfo.agencyBranchNumber}:${x.requestType}`)
    const distinct = [...new Set(keys)]
    return distinct.length === 1
  }

  /**
   * 依頼受付ボタンの無効
   */
  get disableRequest() {
    return this.selectItems.length !== 1 || this.selectItems.filter(x => x.requestNos.length !== 0).length !== 0
  }

  /**
   * 複写作成ボタンの無効
   */
  get disableEstimateCopy() {
    return this.selectItems.length !== 1
  }

  /**
   * 初期実行
   */
  mounted() {
    /* 初期検索 */  
    const conditions = sessionStorage.getItem("tool.estimate.list.conditions")
    if (conditions !== null) {
      this.conditions = JSON.parse(conditions) as SerchConditon
    }
    const searchFilter = sessionStorage.getItem("tool.estimate.list.searchFilter")
    if (searchFilter !== null) {
      this.searchFilter = searchFilter
    }
    this.search()
  }

  /**
   * 検索処理
   */
  search() {
    this.showLoading()
    sessionStorage.setItem("tool.estimate.list.conditions", JSON.stringify(this.conditions))
    this.estimatesService.findAll(this.conditions)
      .then(x => {
        this.list = x
        this.selectItems = []
        this.mountedDataTable("tool.estimate.list")
        this.hideLoading()
      })
      .catch(error => {
        // eslint-disable-next-line
        console.log(error)
        this.alert("検索エラー", ALERT_TYPE.ERROR)
        this.hideLoading()
      })
  }

  /**
   * フィルター処理
   */
  // eslint-disable-next-line
  customFilter(value: any, search: string | null, item: Estimate): boolean {
    return this.filterCompare(search, item.filterKeyword)
  }

  /**
   * 行クリック時の処理
   */
  onClickRow(event: Estimate) {
    const now = (new Date()).getTime()
    if ((now - this.rowItemClickTime) <= 500 && this.rowItemKey === event.estimateNo) {
      this.$router.push(`/member/estimate/edit/${event.estimateNo}`)
    }
    this.rowItemKey = event.estimateNo
    this.rowItemClickTime = now
  }

  /**
   * 印刷ボタンのクリック
   */
  onPrint(estimateNo: string) {
    this.estimatesService.print(estimateNo)
      .then(dto => {
        this.list.filter(x => x.estimateNo === estimateNo)
            .forEach(x => x.printAt = dto.printAt)
        this.openPdfViewDialog("見積書印刷", dto.estimateFile.content)
      })
  }

  /**
   * メール一括送信ボタンのクリック
   */
  onMail() {
    const estimateNos = this.selectItems.map(x => x.estimateNo)
    this.onSendMail(estimateNos)
  }

  /**
   * メール送信ボタンのクリック
   */
  onSendMail(estimateNos: string[]) {
    this.mailSendEstimateNos = estimateNos
    this.estimatesService.generateMailTemplate(this.mailSendEstimateNos)
      .then(x => {
        this.sendMail = x
        this.mailSendDialog = true
      })
      .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
          this.alert("メール送信テンプレートの取得に失敗しました", ALERT_TYPE.ERROR)
          this.hideLoading()
      })
  }

  /**
   * メール送信
   */
  onSendMailed(event: SendMail) {
    this.showLoading()
    const mailQueue = new MailQueue({to: event.to, cc: event.cc, bcc: event.bcc, replyTo: event.replyTo, subject: event.subject, content: event.content, estimateNos: this.mailSendEstimateNos})
    this.estimatesService.mailQueuePush(mailQueue)
      .then((x) => {
          this.list.filter(y => mailQueue.estimateNos.indexOf(y.estimateNo) >= 0)
            .forEach(y => y.mailSendAt = x.mailSendAt)
          this.alert("メール送信しました", ALERT_TYPE.SUCCESS)
          this.hideLoading()
      })
      .catch((error) => {
          // eslint-disable-next-line
          console.log(error)
          this.alert("メール送信に失敗しました", ALERT_TYPE.ERROR)
          this.hideLoading()
      })
  }

  /**
   * 依頼受付
   */
  onRequest() {
    const query = this.selectItems.map(x => x.estimateNo)
        .join(",")
    this.$router.push("/member/request/new?refs=" + query)
  }

  /**
   * 複写作成
   */
  onEstimateCopy() {
    // eslint-disable-next-line
    const query = this.selectItems.map(x => x.estimateNo).find(x => true)
    this.$router.push("/member/estimate/new?copy=" + query)
  }

  /**
   * フィルター変更
   */
  @Watch("searchFilter")
  changeSearchFilter() {
    sessionStorage.setItem("tool.estimate.list.searchFilter", this.searchFilter)
  }

  /**
   * 画面を遷移する前の状態保存
   */
  // eslint-disable-next-line
  beforeRouteLeave(to: VueRouter, from: VueRouter, next: any) {
    sessionStorage.setItem("tool.estimate.list.dataTableOptions", JSON.stringify(this.dataTableOptions))
    sessionStorage.setItem("tool.estimate.list.windowPosition", JSON.stringify(WindowPosition.now()))
    next()
  }
}
